import { Anchor, FlexRow, IconContainer, Text } from '@epam/promo';
import { ReactComponent as ShapeIcon } from '../../assets/svg/gitlab2.svg';
const AddGitlabFile = ({
  onClick,
  isInvalid,
}: {
  onClick: (e?: any) => void;
  isInvalid?: boolean;
}) => {
  return (
    <div
      style={{
        width: '46%',
        position: 'relative',
        minHeight: '104px',
        border: isInvalid ? '2px dashed #e54322' : '2px dashed #CED0DB',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        whiteSpace: 'pre',
        marginLeft: 4,
      }}
      onClick={onClick}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <FlexRow size="24" spacing="6">
          <IconContainer color="blue" icon={ShapeIcon} />
          <Text lineHeight="24" size="24" fontSize="14" font="sans-semibold">
            {' '}
            {'Add a file from'}{' '}
          </Text>
          <Anchor>
            {' '}
            <span style={{ color: '#008ACE' }}>{'Gitlab'}</span>
          </Anchor>
        </FlexRow>

        <Text lineHeight="24" size="24" fontSize="14" color="gray60">
          {'PPT/PPTX/PDF files under 50 MB'}
        </Text>
      </div>
    </div>
  );
};

export default AddGitlabFile;
